const getDefaultState = () => {
	return {contractIdForSignature: false}
}


const state = getDefaultState()

const getters = {
	getContractIdForSignature: (state) => state.contractIdForSignature
}

const mutations = {
	resetContractSignatureState: (state) => Object.assign(state, getDefaultState()),
	setContractIdForSignature: (state, id) => state.contractIdForSignature = id
}

const actions = {
	setContractIdForSignature({commit, getters}, id) {
		commit('setContractIdForSignature', id);
	},
	resetContractIdForSignature({commit, getters}) {
		commit('setContractIdForSignature', false);
	}
}

export default {
    state,
    getters,
    mutations,
    actions
}
